/* tslint:disable */
/* eslint-disable */
export enum DisputeTypeEnum {
  Chargeback = 'Chargeback',
  Retrieval = 'Retrieval'
}
